import { HttpIgnore, IResource, Model, ObjectCollection, ResponseFill, ValidationCNPJ } from 'simpli-web-sdk'
import { ItrackCollection } from '@/helpers'
import moment from 'moment'

@HttpIgnore()
export default class ClientNotificationRequest extends Model {
    readonly $name: string = 'ClientNotification'

    allTipoNotificacaoCarga = ItrackCollection.allTipoNotificacaoCarga.prependNull('app.all')

    @ResponseFill('start')
    startDate: string | null = null

    endDate: string | null = null

    @ResponseFill('notificacao')
    notificacao: number | null = null

    @ResponseFill('observacao')
    observacao: string | null = null

    @ResponseFill('cnpj')
    @ValidationCNPJ()
    documentDestinatario: string | null = null

    @ResponseFill('cnpjEmbarcadorTransportador')
    @ValidationCNPJ()
    documentResponsavel: string | null = null

    @ResponseFill('nroFiscal')
    docs: string | null = null

    @ResponseFill('searchByCTE')
    searchByCTE: string | null = null

    @ResponseFill()
    manifesto: string | null = null

    allCte = new ObjectCollection()
    allDocs = new ObjectCollection()

    @ResponseFill()
    get end() {
        // we should send the next day to the server, the prop endDate is used only to control what the user input
        return !this.endDate ? this.endDate : moment(this.endDate).add(1, 'day').format()
    }

    set end(val) {
        if (val) {
            // in the way back we need to subtract, so the params in the route dont mess up
            this.endDate = moment(val).subtract(1, 'day').format()
        }
    }

    get docsResource() {
        const str = String(this.docs || '')
        const docs = str.split(',')
        return this.allDocs.getMany(docs)
    }
    set docsResource(val: IResource[]) {
        this.docs = val.map((item: IResource) => item.$id).join(',')
    }

    get cteResource() {
        const str = String(this.searchByCTE || '')
        const cte = str.split(',')
        return this.allCte.getMany(cte)
    }
    set cteResource(val: IResource[]) {
        this.searchByCTE = val.map((item: IResource) => item.$id).join(',')
    }

    cleanSearchByCTE() {
        this.searchByCTE = ''
    }

    cleanDocs() {
        this.docs = ''
    }

    populateSearchByCTE(val: IResource[]) {
        this.allCte = new ObjectCollection(val)
    }

    populateAllDocs(val: IResource[]) {
        this.allDocs = new ObjectCollection(val)
    }

    get notificacaot() {
        return this.allTipoNotificacaoCarga.get(this.notificacao)
    }

    set notificacaot(val: IResource | null) {
        this.notificacao = val && val.$id as number || null
    }
}
